<template>
  <footer class="ignore-footer-component">
    <div class="footer-logo"><img :src="footerLogo" alt=""></div>
    <div class="footer-item">市场合作：gfhcapp@qq.com</div>
    <div class="footer-item">公司地址：深圳市宝安区石岩街道浪心社区青年西路17号松石苑1903</div>
    <div class="footer-item">版权所有：众行融资租赁（深圳）有限公司</div>
    <div class="footer-item">
        <a href="https://beian.miit.gov.cn/" target="_blank" style="color: grey; text-decoration: none;">备 案 号 ：{{ $root.copyright }}</a>
      </div>
    <div class="code-board">
      <div class="code-box">APP下载<img :src="appCode" alt="APP二维码"></div>
      <div class="code-box">关注我们<img :src="qrcode" alt="关注二维码"></div>
    </div>
  </footer>
</template>

<script>
import appCode from '../../assets/app-code.png';
import qrcode from '../../assets/qrcode_gfhc.jpg';
import footerLogo from '../../assets/footer-logo.png';

export default {
  data () {
    return {
      appCode,
      qrcode,
      footerLogo
    };
  }
};
</script>

<style lang="scss" scoped>
.ignore-footer-component {
  width: 100%;
  background-color: #000000;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 30px;

  .footer-logo {
    width: 20vw;
    margin-bottom: 15px;
  }
  .footer-logo img {
    width: 100%;
  }

  .footer-item {
    font-size: 12px;
    transform: scale(0.9);
    color: #808080;
    margin-bottom: 10px;
  }

  .code-board {
    display: flex;
  }

  .code-box {
    text-align: center;
    font-size: 12px;
    transform: scale(0.9);
    color: #CCCCCC;
    width: 20vw;
    min-width: 60px;
    margin-bottom: 30px;
  }
  .code-box img {
    display: inline-block;
    margin-top: 6px;
    margin-bottom: 10px;
    width: 100%;
  }
}
</style>
